import React from "react";
import { Link } from "react-router-dom";
import HeaderAccountDropdown from "./HeaderAccountDropdown";

const Header = (props) => {
  const { topbarIsOpen, toggleTopbar } = props;
  const { loanUUID } = props;
  return (
    <header className="fincoHeader1">
      <div className="container-fluid">
        <div className="row">
          <div className="col-6">
            <div className={(topbarIsOpen ? " _miniHam" : "") + " hamImg_box"}>
              <Link to="/">
                <img src={`/image/${topbarIsOpen ? "fincobox_minIcon" : "fincobox_com"}.png`} alt="" />
              </Link>
            </div>
          </div>
          <div className="col-6">
            <div className="adminSide d-flex align-items-center justify-content-end">
              <HeaderAccountDropdown loanUUID={loanUUID} />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
